import Franchise from './Franchise';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageButtons from "../../components/PageButtons";
import { useForm } from 'react-hook-form';
import { useFranchises } from '../../hooks/UseFranchises';
import {PAGINATION} from "../../constants"; // Assuming a custom hook for franchises API.

const PAGE_SIZE = PAGINATION.FRANCHISES_PAGE_SIZE;

function FranchiseList(params) {
    const user = params.user;
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const currentPage = Number.parseInt(searchParams.get('page') ?? '1');
    const pageSearch = searchParams.get('filter') ?? '';

    const useFranchisesHook = useFranchises(); // Custom hook for fetching franchises.
    const { register, handleSubmit, reset } = useForm({
        defaultValues: { search: pageSearch }
    });

    const onButtonClicked = (index) => {
        setSearchParams({ page: index, filter: pageSearch });
        window.scrollTo(0, 0);
    };

    const onEditClicked = (franchise) => {
        navigate(`/franchises/edit?id=${franchise.id}`);
    };

    function OnSearchClicked(data) {
        const newFilter = data.search || '';
        setSearchParams({ page: 1, filter: newFilter });
    }

    useEffect(() => {
        useFranchisesHook.loadCount(user.token, pageSearch);
    }, [user.token, pageSearch]);

    useEffect(() => {
        reset({ search: pageSearch });
    }, [pageSearch, reset]);

    useEffect(() => {
        const offset = (currentPage - 1) * PAGE_SIZE;

        if (user.token) {
            console.log("🚀 Завантаження франшиз:", currentPage, "Offset:", offset);
            useFranchisesHook.loadAll(user.token, PAGE_SIZE, offset, pageSearch);
        }
    }, [user.token, currentPage, pageSearch]);

    const totalPages = Math.ceil((useFranchisesHook.count || 0) / PAGE_SIZE);

    if (useFranchisesHook.loading && !useFranchisesHook.franchises) {
        return <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>;
    }

    const franchiseElements = useFranchisesHook.franchises?.map(f => (
        <Franchise user={user} franchise={f} onEditClicked={onEditClicked} key={f.id} />
    ));

    return (
        <div>
            {/* Search Panel */}
            <div style={{
                backgroundColor: '#fff',
                padding: '15px',
                borderRadius: '12px',
                marginBottom: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
                <form onSubmit={handleSubmit(OnSearchClicked)} style={{ display: 'flex', gap: '10px' }}>
                    <input
                        style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }}
                        {...register('search')}
                        placeholder="Пошук за назвою франшизи..."
                    />
                    <button type="submit" style={{
                        padding: '10px 25px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#1f2937',
                        color: '#fff',
                        cursor: 'pointer'
                    }}>
                        Знайти
                    </button>
                </form>
            </div>

            {/* Franchise Grid */}
            {useFranchisesHook.count === 0 ? (
                <div style={{ textAlign: 'center', padding: '50px', color: '#6b7280' }}>Нічого не знайдено</div>
            ) : (
                <>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(450px, 1fr))',
                        gap: '20px',
                        paddingBottom: '30px'
                    }}>
                        {franchiseElements}
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                            <PageButtons totalPages={totalPages} currentPage={currentPage} onButtonClicked={onButtonClicked} />
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default FranchiseList;